/**
 *
 * Asynchronously loads the component for Environment
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Environment = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.Environment,
);
